import Address from './Address.js';

/**
 * Defines a customer.
 */
export default class Customer {
    /**
     * Set all attributes.
     * @param {object} customer
     */
    constructor(customer) {
        this.id = customer.id;
        this.customerNumber = customer.customer_number;
        this.organization = customer.organization;
        this.is_partner = customer.is_partner;
        this.name = customer.name;
        this.firstName = customer.first_name;
        this.lastName = customer.last_name;
        this.fullName = customer.full_name;
        this.phone = customer.phone;
        this.email = customer.email;
        this.creditLimit = customer.credit_limit;
        this.address = null;
        if (customer.address) {
            this.address = new Address(customer.address);
        }
        this.isValidated = customer.is_validated;
        this.availableActions = customer.available_actions || [];
        this.invoiceHistoryUrl = customer.invoice_history_url;
    }
}
